import * as React from 'react';
import { Tooltip } from '@cian/ui-kit';
import { Label } from './Label';
import * as styles from './BuilderStatus.css';

export interface IBuilderStatusProps {
  labelText: string;
  tooltipTitle: string;
  tooltipText: string;
}

export function BuilderStatus(props: IBuilderStatusProps) {
  const { labelText, tooltipText, tooltipTitle } = props;

  return (
    <div className={styles['container']}>
      <Tooltip
        placement={'bottom'}
        theme={'white'}
        title={
          <>
            <div className={styles['title']}>{tooltipTitle}</div>
            <div className={styles['text']}>{tooltipText}</div>
          </>
        }
      >
        <span>
          <Label labelText={labelText} />
        </span>
      </Tooltip>
    </div>
  );
}
